import { useI18n } from "../i18n/I18nContext";
import { Reveal, Stagger, StaggerItem } from "../components/Reveal";
import { PageHero, CtaBlock } from "../components/Shared";

const HERO_IMG =
  "https://images.unsplash.com/photo-1545569310-c977a299d4e7?auto=format&fit=crop&w=1920&q=80";

export default function Travel() {
  const { t } = useI18n();
  return (
    <>
      <PageHero
        overline={t.travel.overline}
        title={t.travel.title}
        desc={t.travel.desc}
        image={t.travel.heroImage || HERO_IMG}
      />

      <section className="bg-midnight border-t border-white/5">
        <div className="max-w-[1440px] mx-auto px-6 md:px-12 lg:px-16 py-20 md:py-28">
          <Reveal>
            <div className="overline mb-6">CITIES · 城市</div>
            <h2 className="font-display font-extrabold tracking-tighter text-white text-3xl sm:text-4xl lg:text-5xl leading-[1.05] max-w-3xl uppercase">
              Главные направления
            </h2>
          </Reveal>
          <Stagger className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-white/5">
            {t.travel.cities.map((c, idx) => (
              <StaggerItem
                key={c.en}
                data-testid={`travel-city-${c.en}`}
                className="group bg-midnight-2 p-8 hover:bg-coral hover:text-midnight transition-all duration-500 cursor-pointer relative overflow-hidden"
              >
                <div className="font-mono text-[11px] tracking-[0.2em] text-coral group-hover:text-midnight uppercase mb-8">
                  {String(idx + 1).padStart(2, "0")} · {c.en}
                </div>
                <h3 className="font-display font-extrabold tracking-tight text-white group-hover:text-midnight text-3xl md:text-4xl leading-tight uppercase">
                  {c.name}
                </h3>
                <p className="mt-3 text-white/55 group-hover:text-midnight/80 text-sm leading-relaxed transition-colors">
                  {c.desc}
                </p>
                <div className="mt-12 flex items-center gap-2 text-white/40 group-hover:text-midnight transition-colors">
                  <span className="line-arrow" />
                </div>
              </StaggerItem>
            ))}
          </Stagger>
        </div>
      </section>

      <CtaBlock title={t.travel.cta} buttonText={t.nav.cta} />
    </>
  );
}
